import { apiFetch } from './api';

export type TipoMidia = 'Video' | 'Foto' | 'Documento';
export type StatusMidia = 'AguardandoUpload' | 'Processando' | 'Pronto' | 'Falhou' | 'Removida';

export type Midia = {
  id: string;
  tipo: TipoMidia;
  status: StatusMidia;
  nomeOriginal: string;
  mimeType: string;
  tamanhoBytes: number;
  duracaoSeg: number | null;
  titulo: string | null;
  descricao: string | null;
  tagsCsv: string | null;
  pacienteId: string | null;
  atendimentoId: string | null;
  cirurgiaId: string | null;
  autorId: string;
  criadoEm: string;
  uploadConcluidoEm: string | null;
  /** Procedimento da cirurgia vinculada, quando houver. */
  procedimentoCirurgia?: string | null;
};

export type RequestUploadResponse = {
  midiaId: string;
  uploadUrl: string;
  blobPath: string;
  expiraEm: string;
};

export const listMidias = (params: {
  tipo?: TipoMidia;
  pacienteId?: string;
  atendimentoId?: string;
  cirurgiaId?: string;
  /** Busca em título, nome do arquivo, tags e procedimento da cirurgia. */
  q?: string;
  /** Período pela data da mídia (ISO). */
  from?: string;
  to?: string;
} = {}) => {
  const qs = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) if (v) qs.set(k, String(v));
  return apiFetch<Midia[]>(`/midia${qs.toString() ? `?${qs}` : ''}`);
};

export const getMidia = (id: string) => apiFetch<Midia>(`/midia/${id}`);

export const requestUpload = (data: {
  tipo: TipoMidia;
  nomeOriginal: string;
  mimeType: string;
  tamanhoBytes: number;
  pacienteId?: string;
  atendimentoId?: string;
  cirurgiaId?: string;
  titulo?: string;
  descricao?: string;
  tagsCsv?: string;
}) => apiFetch<RequestUploadResponse>('/midia/upload-url', { method: 'POST', body: JSON.stringify(data) });

export const completeUpload = (id: string, data: { duracaoSeg?: number; sha256?: string } = {}) =>
  apiFetch<void>(`/midia/${id}/complete`, { method: 'POST', body: JSON.stringify(data) });

export const getDownloadUrl = (id: string) =>
  apiFetch<{ url: string }>(`/midia/${id}/download-url`);

export const deleteMidia = (id: string) =>
  apiFetch<void>(`/midia/${id}`, { method: 'DELETE' });

/** Faz PUT direto no Azure Blob com a URL SAS retornada pela API. */
export async function uploadToBlob(file: File, uploadUrl: string): Promise<void> {
  const res = await fetch(uploadUrl, {
    method: 'PUT',
    headers: {
      'x-ms-blob-type': 'BlockBlob',
      'Content-Type': file.type || 'application/octet-stream',
    },
    body: file,
  });
  if (!res.ok) {
    throw new Error(`Upload falhou: ${res.status} ${res.statusText}`);
  }
}
